<template>
  <vz-col v-if="date" class="run-schedule-calculation-item">
    <div v-if="title" class="run-schedule-calculation-item-title text-medium mb-20">
      {{ title}}
    </div>
    <div :class="withoutTitleStyle">
      {{ date }}{{ timeText(time) }}
    </div>
    <div v-if="terminal" class="run-schedule-calculation-item-terminal mt-20">
      <vz-icon
        name="map-marker"
        variant="low"
        size="16"
        class="mr-5"
      />
      <a :href="terminalAddressHref(city, terminal)" target="_blank">
        {{ terminal }}
      </a>
    </div>
  </vz-col>
  <run-schedule-calculation-item-skeleton v-else :title="title"/>
</template>

<script setup lang='ts'>
import { PropType } from 'vue'
import {KeyValueObject, Location} from '~/types/types'
import { getFullLinkRedirect } from '~/common/functions'
import RunScheduleCalculationItemSkeleton from '~/components/public/run-schedule/run-schedule-calculation-item-skeleton.vue'

const props = defineProps({
  title:{
    type: String,
    default: ''
  },
  date: {
    type: String,
    default: ''
  },
  time: {
    type: [String, Object],
    default: ''
  },
  terminal: {
    type: String,
    default: ''
  },
  city: {
    type: Object as PropType<Location>,
    default: () => ({})
  }
})

const withoutTitleStyle = computed(() => {
  return props.title ? '' : 'mt-45' 
})

function timeText(time: KeyValueObject | String): string {
  if (time) {
    return typeof time === 'object'
      ? `, после ${Object.keys(time)[0]} до ${Object.values(time)[0]}`
      : `, до ${time}`
  } 
  return ''
}

function terminalAddressHref(city: Location, terminal: string): string {
  return terminal?.length && city ? getFullLinkRedirect(city, `/contacts/?terminal=${terminal}`) : ''
}
</script>
